// extracted by mini-css-extract-plugin
export default {"innerWrapper":"uw-z","tooltipWrapper":"vw-z","icon":"ww-z","tooltip":"xw-z","content":"yw-z"};